import { fromJS, Map } from 'immutable';
import types from '../constants/propertyConstant';

const INITIAL_STATE = {
  building: { data: [], isLoading: true },
  application: { data: [], isLoading: true },
  policy: { data: [], isLoading: true },
  'policy-cancel': { data: [], isLoading: true },
  claim: { data: [], isLoading: true },
  'policy-cancel-logs': { data: [], isLoading: true, total: 0 },
};

const initialImmutableState = fromJS(INITIAL_STATE);

const propertyReducer = (state = initialImmutableState, action = {}) => {
  switch (action.type) {
    case types.GET_BUILDING:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['building'], (building = Map()) =>
          building.merge(fromJS({ isLoading: true, buildingError: null })),
        );
      });
    case types.SET_BUILDING:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'building',
          fromJS({ ...action.payload, isLoading: false, buildingError: null }),
        );
      });
    case types.SET_BUILDING_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['building'], (building = Map()) =>
          building.merge(
            fromJS({
              isLoading: false,
              buildingError: action.payload || 'Unable to load properties.',
            }),
          ),
        );
      });
    ////////////////////////////
    case types.GET_APP:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['application'], (application = Map()) =>
          application.merge(fromJS({ isLoading: true, applicationError: null })),
        );
      });
    case types.SET_APP:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'application',
          fromJS({ ...action.payload, isLoading: false, applicationError: null }),
        );
      });
    case types.SET_APP_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['application'], (application = Map()) =>
          application.merge(
            fromJS({
              isLoading: false,
              applicationError: action.payload || 'Unable to load applications.',
            }),
          ),
        );
      });
    ////////////////////////////
    case types.GET_CLAIM:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['claim'], (claim = Map()) =>
          claim.merge(fromJS({ isLoading: true, claimError: null })),
        );
      });
    case types.SET_CLAIM:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'claim',
          fromJS({ ...action.payload, isLoading: false, claimError: null }),
        );
      });
    case types.SET_CLAIM_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['claim'], (claim = Map()) =>
          claim.merge(
            fromJS({
              isLoading: false,
              claimError: action.payload || 'Unable to load claims.',
            }),
          ),
        );
      });
    ////////////////////////////
    case types.GET_POLICY:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['policy'], (policy = Map()) =>
          policy.merge(fromJS({ isLoading: true, policyError: null })),
        );
      });
    case types.SET_POLICY:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'policy',
          fromJS({ ...action.payload, isLoading: false, policyError: null }),
        );
      });
    case types.SET_POLICY_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['policy'], (policy = Map()) =>
          policy.merge(
            fromJS({
              isLoading: false,
              policyError: action.payload || 'Unable to load policies.',
            }),
          ),
        );
      });
    ////////////////////////////
    case types.GET_POLICY_CANCEL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['policy-cancel'], (building = Map()) =>
          building.set('isLoading', true),
        );
      });
    case types.SET_POLICY_CANCEL:
      return state.withMutations((mutableState) => {
        mutableState.set('policy-cancel', fromJS({ ...action.payload, isLoading: false }));
      });
    case types.SET_ERR:
      return state.withMutations((mutableState) => {
        mutableState.set('error', fromJS(action.payload));
      });
    case types.SET_BUILDING_DELEGATION:
      return state.withMutations((mutableState) => {
        mutableState.set('delegation', fromJS(action.payload));
      });
    case types.SET_BUILDING_INVOICE:
      return state.withMutations((mutableState) => {
        mutableState.set('invoice', fromJS(action.payload));
      });
    case types.GET_POLICY_CANCEL_LOGS:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['policy-cancel-logs'], (cancelLogs = Map()) =>
          cancelLogs.merge(fromJS({ isLoading: true, cancelLogsError: null })),
        );
      });
    case types.SET_POLICY_CANCEL_LOGS:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'policy-cancel-logs',
          fromJS({ ...action.payload, isLoading: false, cancelLogsError: null }),
        );
      });
    case types.SET_POLICY_CANCEL_LOGS_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['policy-cancel-logs'], (cancelLogs = Map()) =>
          cancelLogs.merge(
            fromJS({
              isLoading: false,
              cancelLogsError: action.payload || 'Unable to load policy cancellation logs.',
            }),
          ),
        );
      });
    case types.GET_POLICY_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['policy-detail'], (policyDetail = Map()) =>
          policyDetail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_POLICY_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'policy-detail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_POLICY_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('policy-detail', fromJS({ data: null, isLoading: false, hasError: true }));
      });
    case types.GET_APP_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['application-detail'], (applicationDetail = Map()) =>
          applicationDetail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_APP_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'application-detail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_APP_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'application-detail',
          fromJS({ data: null, isLoading: false, hasError: true }),
        );
      });
    case types.GET_CLAIM_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['claim-detail'], (claimDetail = Map()) =>
          claimDetail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_CLAIM_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'claim-detail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_CLAIM_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('claim-detail', fromJS({ data: null, isLoading: false, hasError: true }));
      });
    case types.GET_BUILDING_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['building-detail'], (buildingDetail = Map()) =>
          buildingDetail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_BUILDING_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'building-detail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_BUILDING_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'building-detail',
          fromJS({ data: null, isLoading: false, hasError: true }),
        );
      });
    default:
      return state;
  }
};

export default propertyReducer;
